import { RootState } from 'store/store';

export const selectDashboardWidgetConfigs = (state: RootState) => state.Dashboard.widgetConfigs;
